import { Routes } from '@angular/router';

const title = 'Configuración';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'horario',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Horario' }] },
        loadComponent: () => import('./pages/horario-detalle/horario-detalle.component'),
      },
    ],
  },
];
